<script setup lang="ts">
import { ref } from 'vue';
import { useApp } from '../stores/app';
import { t } from '../i18n';
import Icon from './Icon.vue';

const app = useApp();
const open = ref(false);
let pressed = false;

function showMenu(): void {
  open.value = true;
}

function hideMenu(): void {
  if (!pressed) open.value = false;
}

function onPointerDown(e: PointerEvent): void {
  if (e.button !== 0) return;
  pressed = true;
  open.value = true;
}

function onPointerUp(): void {
  pressed = false;
}

function create(): void {
  void app.createCanvas();
}

function wip(): void {
  open.value = false;
  app.notify('info', t('home.inDevelopment'));
}
</script>

<template>
  <div
    class="add-wrap"
    @mouseenter="showMenu"
    @mouseleave="hideMenu"
    @pointerdown="onPointerDown"
    @pointerup="onPointerUp"
    @pointercancel="onPointerUp"
  >
    <button type="button" class="pill tall primary" @click="create">
      <Icon name="plus" :size="15" />{{ t('home.add') }}
    </button>
    <div class="add-menu glass" :class="{ open }" role="menu" :aria-label="t('home.add')" @click.stop>
      <button type="button" role="menuitem" @click="wip">{{ t('home.addNotebook') }}</button>
      <button type="button" role="menuitem" @click="wip">{{ t('home.addSpace') }}</button>
    </div>
  </div>
</template>

<style scoped>
.add-wrap {
  position: relative;
}
.pill.tall {
  height: 36px;
  padding: 0 16px;
  font-size: 13px;
}
.pill.primary {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--on-accent);
}
.pill.primary:hover {
  background: var(--accent-2);
  color: var(--on-accent);
}
.add-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  min-width: 148px;
  padding: 4px;
  border-radius: var(--radius-panel);
  opacity: 0;
  transform: translateY(-4px);
  pointer-events: none;
  transition:
    opacity 0.18s ease,
    transform 0.18s ease;
  z-index: 30;
}
.add-menu.open {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}
.add-menu button {
  display: block;
  width: 100%;
  text-align: left;
  padding: 8px 12px;
  border: none;
  border-radius: var(--radius-control);
  background: transparent;
  color: var(--text);
  font-size: 13px;
  cursor: pointer;
}
.add-menu button:hover {
  background: color-mix(in srgb, var(--text) 8%, transparent);
}
@media (prefers-reduced-motion: reduce) {
  .add-menu {
    transition: none;
  }
}
</style>
